import { useActiveCirclePacks } from '../use-packs';

export function useMediaPack(packClass?: string) {
    const { packs, ...otherProps } = useActiveCirclePacks(
        packClass ? [packClass] : []
    );
    return { packClass: packs?.[0], ...otherProps };
}
